import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from '@app/services/user.service';
import { Utilities } from '@app/common/utilities';
import { Observable } from 'rxjs';
import { User } from '@microsoft/microsoft-graph-types';
import { SecurityService } from '@app/services/security.service';
import { AuthService } from '@app/services/auth.service';
import { Constants } from '@app/common/constants';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent implements OnInit {

  userIsAdmin$: Observable<boolean>;

  userProfile$: Observable<User>;
  hasPermission$: Observable<boolean>;

  constructor(private userService: UserService, private authService: AuthService, private securityService: SecurityService) { }

  getPictureUrl(userProfile: User): Observable<string> {
    return this.userService.getUserPhotoByUpn(userProfile.userPrincipalName);
  }

  getPreferredNameLetters(userProfile: User) {
    return Utilities.generateInitials(userProfile.displayName);
  }

  logOut() {
    this.authService.logOut();
  }

  ngOnInit() {
    this.userProfile$ = this.userService.getMyDetailsFromMsGraph();
    this.userIsAdmin$ = this.securityService.hasUserPdpRole(Constants.PDP_ROLE_ADMIN);
  }

}
